// 获取消息列表分页
export function getMessagePageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/message/pageList',
    data
  })
}

// 标记为已读
export function markMessageAsRead(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/message/markAsRead',
    data
  })
}

// 全部标记为已读
export function markAllAsRead(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/message/markAllAsRead',
    data
  })
}
